import classes from './LabelValue.module.scss';

const LabelValue = ({ className, name, label, value, children, classValue }) => {
  const containerClasses = [classes.container];
  if (className) {
    containerClasses.push(className);
  }
  const classesValues = [classes.value];
  classValue && classesValues.push(classValue, 'text-ellipsis');
  containerClasses.join(' ');

  return (
    <div className={containerClasses.join(' ')}>
      <label name={`${name}.label`} className={`medium-12 ${classes.label}`} htmlFor={name}>
        {label}
      </label>
      <span name={`${name}.value`} title={value} className={`semibold-16  ${classesValues.join(' ')}`}>
        {value}
      </span>
      {children}
    </div>
  );
};

export default LabelValue;
